import React from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";

import Home from "./pages/Home";
import Servicios from "./pages/Servicios";
import Novedades from "./pages/Novedades";
import Clientes from "./pages/Clientes";
import QuienesSomos from "./pages/QuienesSomos";
import Certificaciones from "./pages/Certificaciones";
import Contacto from "./pages/Contacto";
import RecursosHumanos from "./pages/RecursosHumanos";
import NoticiaDetalle from "./pages/NoticiaDetalle";

import FormularioCV from "./components/FormularioCV";
import Login from "./components/Login";
import DevNavbar from "./components/DevNavbar";
import NavbarSevicol from "./components/NavbarSevicol";
import FooterSevicol from "./components/FooterSevicol";
import ContactoOpciones from "./pages/ContactoOpciones";


import RequireAuth from "./components/RequireAuth";

// Admin / Dev
import AdminPanel from "./components/AdminPanel";                  // listado de postulantes
import AdminHome from "./pages/AdminHome";
import AdminClientesEmpresas from "./pages/AdminClientesEmpresas";
import AdminClientesSucursales from "./pages/AdminClientesSucursales";
import ServiciosAdmin from "./components/ServiciosAdmin";
import AdminNovedades from "./pages/AdminNovedades";
import CreateUser from "./components/CreateUser";                  // ⬅️ formulario crear usuario

import { getRole, isLoggedIn } from "./services/auth";
import AdminUsers from "./components/AdminUser";

export default function App() {
  const { pathname } = useLocation();
  const isBackoffice = pathname.startsWith("/admin");

  // Redirección inteligente al entrar a /admin
  const AdminRedirect = () => {
    if (!isLoggedIn()) return <Navigate to="/login" replace />;
    const role = getRole();
    if (role === "admin" || role === "view") return <Navigate to="/admin/postulantes" replace />;
    if (role === "dev") return <Navigate to="/admin/home" replace />;
    return <Navigate to="/" replace />;
  };

  return (
    <>
      {isBackoffice ? <DevNavbar /> : <NavbarSevicol />}

      <Routes>
        {/* Públicas */}
        <Route path="/" element={<Home />} />
        <Route path="/servicios" element={<Servicios />} />
        <Route path="/novedades" element={<Novedades />} />
        <Route path="/novedades/:slug" element={<NoticiaDetalle />} />
        <Route path="/clientes" element={<Clientes />} />
        <Route path="/quienes-somos" element={<QuienesSomos />} />
        <Route path="/certificaciones" element={<Certificaciones />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/recursos" element={<RecursosHumanos />} />
        <Route path="/formularioCV" element={<FormularioCV />} />
        <Route path="/contactanos" element={<ContactoOpciones />} />
        <Route path="/login" element={<Login />} />

        {/* /admin base -> redirige según rol */}
        <Route path="/admin" element={<AdminRedirect />} />

        {/* Rutas SOLO DEV */}
        <Route element={<RequireAuth roles={['dev']} />}>
          <Route path="/admin/home" element={<AdminHome />} />
          <Route path="/admin/clientes/empresas" element={<AdminClientesEmpresas />} />
          <Route path="/admin/clientes/sucursales" element={<AdminClientesSucursales />} />
          <Route path="/admin/servicios/nuevo" element={<ServiciosAdmin />} />
          <Route path="/admin/novedades" element={<AdminNovedades />} />
        </Route>

        {/* Rutas SOLO ADMIN (gestión de usuarios) */}
        <Route element={<RequireAuth roles={['admin']} />}>
        <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/users/new" element={<CreateUser />} />
        </Route>

        {/* Rutas ADMIN + VIEW (postulantes) */}
        <Route element={<RequireAuth roles={['admin','view']} />}>
          <Route path="/admin/postulantes" element={<AdminPanel />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {!isBackoffice && <FooterSevicol />}
    </>
  );
}

